/**
 * `marcheStore` — **qui tu embauches pour la prochaine vidéo** ⟦A-4 E · M3.30⟧.
 *
 * État **transient et par onglet**, comme `atelierStore` : le plan d'embauche n'est ni une
 * règle ni un état de moteur — c'est une intention d'interface, consommée quand la production
 * se lance (`NouvelleVideo` la copie dans le brouillon) et jetée avec elle. Le moteur, lui,
 * n'apprend les embauches qu'au moment de `produce_video`, dans `scores.delegated` /
 * `scores.freelances` — le SEUL endroit qui écrit `state.freelances` reste la publication.
 *
 * Un choix par étape, identifié par l'id du freelance. Pas de « déléguer sans dire à qui » :
 * le défaut moteur (le moins cher) existe pour les appelants historiques, mais un JOUEUR
 * choisit une personne — c'est toute la différence entre un marché et un interrupteur.
 */

import { create } from "zustand";

import type { AtelierStage } from "@maxime/shared";

export type PlanEmbauche = Partial<Record<AtelierStage, string>>;

interface MarcheStore {
  /** étape → id du freelance retenu pour la prochaine production. */
  plan: PlanEmbauche;
  embaucher(stage: AtelierStage, freelanceId: string): void;
  reprendre(stage: AtelierStage): void;
  vider(): void;
}

export const useMarcheStore = create<MarcheStore>((set, get) => ({
  plan: {},

  embaucher(stage, freelanceId) {
    set({ plan: { ...get().plan, [stage]: freelanceId } });
  },

  reprendre(stage) {
    const { [stage]: _, ...reste } = get().plan;
    set({ plan: reste });
  },

  vider() {
    set({ plan: {} });
  },
}));

/** Les étapes du plan qui concernent CE format (un short n'a ni miniature ni promotion). */
export function planPourFormat(
  plan: PlanEmbauche,
  format: "short" | "longue",
): PlanEmbauche {
  if (format === "longue") return { ...plan };
  const copie = { ...plan };
  delete copie.miniature;
  delete copie.promotion;
  return copie;
}
